import React, { useRef, useCallback, useState, useEffect } from 'react'
import { is } from 'immutable'
import cn from 'classnames'
import { useMount, useUpdateEffect, usePrevious, useScroll } from 'react-use'
import { useSelector, useDispatch } from 'react-redux'
import { getMessagesIds, sessionMessageInfo } from '@/models/messages/selectors'
import * as orderSelectors from '@/models/orders/selectors'
import { messageRetract } from '@/models/conversations/services';
import { Avatar, Input, Empty, Icon, Tooltip, Button, Popconfirm, message } from 'antd'
import { fetchMessages, removeMessage } from '@/models/messages/actions'
import styles from './styles.module.less'
import MessageItem from './Item'
import Member from './Member'
import { taskRefreshKeySelector } from '@/models/taskHall/selectors';
import { convRefreshKeySelector } from '@/models/conversations/selectors';
import { findById } from '@/models/orders/selectors';

let prevScrollTop = 0
let onceSrolling = false
const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';
export default function MessageList({
  orderId,
  readOnly = false,
  onChat,
  onEndConversation,
}) {

  const dispatch = useDispatch()
  const messageIds = useSelector(getMessagesIds(orderId), is)
  const sessionInfo = useSelector(sessionMessageInfo(orderId), is)
  const prevOrderId = usePrevious(orderId)
  const $scrollEl = useRef(null)
  const { x, y } = useScroll($scrollEl)

  const taskRefreshKey = useSelector(taskRefreshKeySelector);
  const convRefreshKey = useSelector(convRefreshKeySelector);

  const order = useSelector(findById(orderId));

  useMount(() => {
    prevScrollTop = 0
    onceSrolling = false

    dispatch(fetchMessages({
      orderId: orderId,
      earlier_at: Date.now(),
      // later_At
    }))

    if (!onceSrolling) {
      scrollToBottom()
    }
  })

  const scrollToBottom = useCallback(() => {
    // requestAnimationFrame(() => {
    if ($scrollEl.current) {
      $scrollEl.current.scrollTop = 999999999999
    }
    // })
  }, [$scrollEl])

  const withdraw = (id) => {
    messageRetract({ id }).then(res => {
      dispatch(fetchMessages({
        orderId: orderId,
        earlier_at: Date.now(),
      }))
      dispatch(removeMessage({
        _id: id,
        order_id: orderId,
      }))
    }).catch((err => {
      message.error(err?.message || '操作失败');
    }))
  }

  useEffect(() => {
    if (convRefreshKey !== 'initkey' || taskRefreshKey !== 'initkey') {
      setTimeout(() => {
        dispatch(fetchMessages({
          orderId: orderId,
          earlier_at: Date.now(),
          // later_At
        }))
        if ($scrollEl.current) {
          $scrollEl.current.scrollTop = 999999999999
        }
      }, 500);

    }
  }, [convRefreshKey, taskRefreshKey])

  useUpdateEffect(() => {
    if (prevOrderId !== orderId) {
      // prevScrollTop = 0
      onceSrolling = false
      dispatch(fetchMessages({
        orderId: orderId,
        earlier_at: sessionInfo?.get('first_ts'),
        // later_At
      }))
    }
    if (!onceSrolling && $scrollEl.current.scrollTop < prevScrollTop) {
      onceSrolling = true
    }

    prevScrollTop = $scrollEl.current.scrollTop
    if (!onceSrolling) {
      scrollToBottom()
    }
  })

  return (
    <div className={styles.messageListWrap} style={{ borderWidth: readOnly ? 0 : '1px' }}>
      {!readOnly && <div className={styles.member}>
        <Member tenant={order?.get('tenant')}>
          <Icon type="team" />
        </Member>
      </div>}
      <div className={styles.messageList} ref={$scrollEl} id="messagesScrollBox">
        <div className={styles.headTips}>
          {
            // sessionInfo.get('hasMore') ? (
            //   <Icon type="loading" />
            // ) : (
            //   <span>-- 没有更早的消息 -- </span>
            // )
          }
        </div>
        {
          messageIds.map(id => {
            return (
              <MessageItem key={id} id={id} readOnly={readOnly} onWithdraw={(id) => {
                withdraw(id)
              }} />
            )
          })
        }
        {/* <Message side="left" avatar="/avatar-girl-default.svg" content="你好，有什么需要帮助的？" /> */}
        {/* <Message side="left" avatar="/avatar-girl-default.svg" content="你好，有什么需要帮助的？" />
      <Message side="left" avatar="/avatar-girl-default.svg" content="你好，有什么需要帮助的？" />
      <Message system content="客服XX为您服务" />
      <Message side="right" avatar="/avatar-robot.svg" content="【派单提醒】 爱上了开发静安寺；了快到计分阿萨德发生地方阿达的发送到FASDASSFDSDGSD施蒂利克噶就是个" />
      <Message side="right" avatar="/avatar-robot.svg" content="【派单提醒】 爱上了开发静安寺；了快到计分阿萨德发生地方阿达的发送到FASDASSFDSDGSD施蒂利克噶就是个" />
      <Message side="left" avatar="/avatar-girl-default.svg" content="你好，有什么需要帮助的？" />
      <Message side="right" avatar="/avatar-robot.svg" content="【派单提醒】 爱上了开发静安寺；了快到计分阿萨德发生地方阿达的发送到FASDASSFDSDGSD施蒂利克噶就是个" /> */}
      </div>
      {(!readOnly && isManagerMode) && <div className={styles.messageBtns}>
        {/* <Popconfirm
          placement="topRight"
          title="确定结束对话吗？"
          onConfirm={() => {
            typeof onEndConversation === 'function' && onEndConversation({ orderId })
          }}
        >
          <Button type="primary" size="small">
            结束对话
          </Button>
        </Popconfirm> */}

        <Button type="link"
          style={{ marginLeft: '10px' }}
          onClick={() => {
            typeof onChat === 'function' && onChat(null, null)
          }}>
          折叠聊天 <Icon type="caret-up" />
        </Button>
      </div>}
    </div>
  );
}
